<div class="image-container">
  <img [src]="image" [alt]="alt" />
</div>
<div class="content">
  <h5>{{ title }}</h5>
  <p [innerHTML]="text"></p>
</div>
